class AcademyCourseTrackReportCardCtrl {
  courseTrack: any;
  user: any;
  featureFlags: any;

  static $inject = ['featureFlags'];

  constructor(featureFlags: any) {
    this.featureFlags = featureFlags;
  }
}

export default AcademyCourseTrackReportCardCtrl;
